var map = {
	"./australia-1.jpg": 61811,
	"./australia.jpg": 5593,
	"./canada-1.jpg": 14535,
	"./canada.jpg": 89893,
	"./china-1.jpg": 56548,
	"./china.jpg": 67062,
	"./france-1.jpg": 11348,
	"./france.jpg": 23910,
	"./london-1.jpg": 75739,
	"./uk-1.jpg": 44929,
	"./uk.jpg": 56047,
	"./usa-1.jpg": 45216,
	"./usa.jpg": 40282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97603;